// extracted by mini-css-extract-plugin
export var container = "_la-0";
export var segment = "_la-2";
export var segmentActive = "_la-3";
export var track = "_la-1";